<!--
    Created by 杨莎莎 on 2025/08/11.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：关联小区-选择关联小区
-->
<style lang="less">

</style>

<template>
  <yg-drawer
    width="60%"
    :show-bottom="false"
    title="选择关联小区"
    @on-close="_close"
  >
    <div
      slot="content"
      style="height: 100%"
    >
      <div>
        <yg-search-area
          :show-info="false"
          :value="searchOption"
          @on-search="_clickSearch"
        />
      </div>
      <div class="padding-primary-top">
        <yg-table
          :columns="tableColumns"
          :data="tableData"
          :page="page"
          @on-page-change="onChangePage"
        />
      </div>
    </div>
  </yg-drawer>
</template>

<script>
import { AssociateMerchantListModel } from '../model/AgentMerchantDataModel';
import AgentApiSet from '@/request/api/AgentApiSet';

export default {
  components: {},
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      searchOption: {
        communityName: BaseSearchModel.initData('小区名称', 'communityName', 'Input')
        // merchantCode: BaseSearchModel.initData('小区编码', 'merchantCode', 'Input')
      },
      tableColumns: [
        BaseTableColumn.initData('index'),
        BaseTableColumn.initData('communityName', '小区名称').setSpan({}),
        BaseTableColumn.initData('communityCode', '小区编码').setSpan({ canCopy: true }),
        BaseTableColumn.initData('operator', '操作').setWidth(100).setButtons([
          { title: '确认关联', name: 'select' }
        ], ({ name }, row, index) => {
          if (name === 'select') {
            this.$emit('on-sure', row);
          }
        })
      ],
      page: { current: 1, total: 0 },
      tableData: []
    };
  },
  created () {
    this.requestData();
  },
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onChangePage (page) {
      this.page.current = page;
      this.requestData();
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    _clickSearch (option) {
      this.searchOption = option;
      this.page.current = 1;
      this.requestData();
    },
    _close () {
      this.$emit('on-close', false);
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 请求数据
    requestData () {
      const api = AgentApiSet.communityList;
      const s = this.searchOption;
      api.params = {
        // merchantNameOrNo: s.merchantName.value || s.merchantCode.value,
        communityName: s.communityName.value,
        pageNo: this.page.current,
        pageSize: this.$config.pageSize
      };
      this.tableData = [];
      this.page.total = 0;
      this.$http(api).then(res => {
        const resData = res.data;
        this.tableData = AssociateMerchantListModel.initListWithDataList(resData.rows);
        this.page.total = resData.total;
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
